import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

window.lazySizesConfig = window.lazySizesConfig || {}; // eslint-disable-line no-undef
window.lazySizesConfig = {
    loadMode: 1,
    expand: Math.max(
        Math.min(document.documentElement.clientWidth, document.documentElement.clientHeight, 1222) - 1,
        359
    ),
    expFactor: lazySizesConfig.expand < 380 ? 3 : 2, // eslint-disable-line no-undef
};

document.addEventListener('lazybeforeunveil', (e) => {
    const { bg } = e.target.dataset;

    if (bg !== undefined) {
        e.target.style.backgroundImage = `url(${bg})`;
    }
});
